import { QueryCache, QueryClient } from '@tanstack/react-query';
import type { QueryClientConfig } from '@tanstack/react-query';
import { message } from 'antd';

/**
 * Types the `meta` object accepted by queries.
 *
 * `onError` was removed from queries in react-query v5, so error toasts are
 * declared through `meta.errorMessage` on the query and displayed once, from
 * the shared `QueryCache` below.
 */
declare module '@tanstack/react-query' {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- module augmentation only merges with an interface
  interface Register {
    queryMeta: {
      errorMessage?: string;
    };
  }
}

export const createQueryClient = (config?: QueryClientConfig) =>
  new QueryClient({
    ...config,
    queryCache: new QueryCache({
      onError: (_error, query) => {
        const { errorMessage } = query.meta ?? {};

        if (errorMessage) {
          message.error(errorMessage);
        }
      },
    }),
  });
